import { Button } from "../../components/ui/Button";
import { Dialog } from "../../components/ui/Dialog";
import { Spinner } from "../../components/ui/misc";
import type { DocumentFull } from "../../lib/api/models";
import { formatTime } from "../../lib/format";

export function ConflictDialog({
  theirs,
  busy,
  onKeepMine,
  onTakeTheirs,
  onCopyMine,
  onRetry,
}: {
  theirs: DocumentFull | "loading" | "failed" | null;
  busy: boolean;
  onKeepMine: () => void;
  onTakeTheirs: () => void;
  onCopyMine: () => void;
  onRetry: () => void;
}) {
  const ready = theirs !== null && theirs !== "loading" && theirs !== "failed";
  return (
    <Dialog
      open={theirs !== null}
      onClose={() => {}}
      dismissible={false}
      size="md"
      title="This document changed while you were editing"
      footer={
        <>
          <Button disabled={!ready || busy} onClick={onCopyMine}>
            Copy mine to a new page
          </Button>
          <Button disabled={!ready || busy} onClick={onTakeTheirs}>
            Take theirs
          </Button>
          <Button variant="primary" disabled={!ready || busy} onClick={onKeepMine}>
            Keep mine
          </Button>
        </>
      }
    >
      {theirs === "failed" ? (
        <div className="grid gap-3 text-ink-2">
          <p>The latest version could not be loaded. Your changes are safe on this device.</p>
          <div>
            <Button onClick={onRetry}>Try again</Button>
          </div>
        </div>
      ) : ready ? (
        <div className="grid gap-3 text-ink-2">
          <p>
            {theirs.updatedBy?.name ?? "Someone"} saved version {theirs.version} at {formatTime(theirs.updatedAt)}. Your
            changes are safe on this device. Choose what to keep:
          </p>
          <dl className="grid gap-2 text-sm">
            <div>
              <dt className="font-medium text-ink">Keep mine</dt>
              <dd>Save your version over theirs. Their version stays in the history.</dd>
            </div>
            <div>
              <dt className="font-medium text-ink">Take theirs</dt>
              <dd>Drop your changes and continue from their version.</dd>
            </div>
            <div>
              <dt className="font-medium text-ink">Copy mine to a new page</dt>
              <dd>Save your version as a new page next to this one, then continue from theirs.</dd>
            </div>
          </dl>
        </div>
      ) : (
        <Spinner label="Loading the latest version…" />
      )}
    </Dialog>
  );
}
